import { takeEvery } from 'redux-saga/effects';

import * as basketActions from 'store/modules/basket';
import { applyDiscount } from './utils';

export default function* listenApplyDiscount() {
  yield takeEvery(basketActions.applyDiscount.toString(), applyDiscount);
}
